"use client";
import { showSideMenuAtom } from "@/hooks/showSideMenuAtom";
import { useAtom } from "jotai";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { PagesPaths } from "@/utils/functions/pages-paths";
import SvgMobileSignIn from "./SvgMobileSignIn";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  mobile?: boolean;
  PcClassName?: string;
}
const SigninBtn: React.FC<Props> = ({ mobile, PcClassName }) => {
  const [, setShowSideMenu] = useAtom(showSideMenuAtom);

  const router = useRouter();
  const t = useTranslation();
  return (
    <button
      className={`${
        mobile ? "signin-btn-mobile" : `pc-signin-btn ${PcClassName ?? ""}`
      }`}
      onClick={() => {
        mobile && setShowSideMenu(false);
        router.push(PagesPaths.signin);
      }}
    >
      {mobile && <SvgMobileSignIn />}
      {t.sign_in}
    </button>
  );
};

export default SigninBtn;
